/** @jsx jsx */
import { jsx } from '@compiled/react';
import { Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { cssMap } from '@atlaskit/css';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import messages from './messages.tsx';

type Props = {
	itemsCount: number;
	totalCount?: number | null;
};

const styles = cssMap({
	paginationDetails: {
		textAlign: 'right',
		color: token('color.text.subtlest'),
		flexGrow: 1,
		flexShrink: 0,
		flexBasis: 'auto',
		marginTop: token('space.0'),
		marginRight: token('space.150'),
		marginBottom: token('space.0'),
		marginLeft: token('space.150'),
		font: token('font.body'),
	},
	fontMedium: {
		fontWeight: token('font.weight.medium'),
	},
});

export const PaginationDetails = ({ itemsCount, totalCount }: Props): JSX.Element | null => {
	const { formatMessage } = useIntl();

	if (totalCount == null) {
		return null;
	}

	return (
		<div
			css={[
				styles.paginationDetails,
				fg('slv-117-nin-column-picker-style-updates') && styles.fontMedium,
			]}
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			data-testid="jql-builder-basic.ui.jql-editor.picker.async-select.pagination-details"
		>
			{formatMessage(messages.ofTotalCount, {
				itemsCount,
				totalCount,
			})}
		</div>
	);
};

export const SimplePaginationDetails = ({ itemsCount, totalCount }: Props): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Text color="color.text.subtlest" weight="medium">
			{formatMessage(messages.ofTotalCount, {
				itemsCount,
				totalCount,
			})}
		</Text>
	);
};
